
export const cmsEnv = (): Environment => {
	// Supported environments are:
	// - Production
	// - Staging
	// - Development (<= default)

	const str = process.env.GATSBY_CONTENT_ENV || 'development';
	switch (str.toLowerCase()) {
	case 'production':
		return Environment.PRODUCTION;
	case 'staging':
		return Environment.STAGING;
	}
	return Environment.DEVELOPMENT;
};

export const isEnvironment = (...envs: Environment[]): boolean => {
	return envs.includes(cmsEnv());
};

export enum Environment {
	PRODUCTION = 'Production',
	STAGING = 'Staging',
	DEVELOPMENT = 'Development',
}
